import { useSelector } from 'react-redux';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { getExperimentDetailsMetadata } from 'modules/experiments/utils/experimentDetails';
import { Card } from 'modules/experiments/components/ui';
import { MONITOR_CARD_HEIGHT } from 'modules/experiments/constants';
import { getExperimentLoadingState } from 'modules/experiments/ducks/selectors';
import { ExperimentDetailsItem } from './Item';
import { StyledCardHeader, CardDetailsGrid } from './Styled';

const CardHeader = () => {
  const { t } = useExperimentsTranslations();
  return <StyledCardHeader>{t('cardHeading.details')}</StyledCardHeader>;
};

export const ExperimentDetails = () => {
  const loading = useSelector(getExperimentLoadingState);
  const experimentDetailsMetadata = getExperimentDetailsMetadata();

  return (
    <Card
      testId="experiments-details"
      cardHeader={<CardHeader />}
      loading={loading}
      height={MONITOR_CARD_HEIGHT.DETAILS}
    >
      <CardDetailsGrid>
        {experimentDetailsMetadata.map((listItem) => {
          const { property, value } = listItem;
          return (
            <ExperimentDetailsItem
              data-test={`${property}`}
              key={`${property}_${value}`}
              property={property as string}
              value={value}
            />
          );
        })}
      </CardDetailsGrid>
    </Card>
  );
};
